import React, { useEffect } from "react";
import { useStyles } from "../../shared/SharedStyles";
import { BuildingCafeList, appInsightsEvents, trackEvent, useAppStore } from "../../../common";
import { BuildingCard } from "../BuildingCard";

interface BuildingListProps {
  buildings: BuildingCafeList[];
}

export const BuildingList = ({ buildings }: BuildingListProps) => {
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);
  const styles = useStyles();

  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "BuildingList",
    });
  }, [context, appInsights]);

  return (
    buildings && (
      // Replace <main> with <div> to avoid multiple main landmarks
      <div
        role="region"
        aria-label="Building List"
        className={styles.listContainer}
        data-testid="buildings"
      >
        {buildings.map((building: BuildingCafeList) => (
          <BuildingCard key={building.id} building={building} />
        ))}
      </div>
    )
  );
};
